import { appSettings } from '@/appSettings';
import { useUser } from '@/login/composables/useUser';
import { useLoginStore } from '@/login/stores/useLoginStore';
import { storeToRefs } from 'pinia';
import saltfish from 'saltfish';
import { computed, ref, watch } from 'vue';

type SaltfishReturn = {
    init: () => void;
    identify: (userId: string, traits?: Record<string, unknown>) => void;
};

export function useSaltfish(): SaltfishReturn {
    const { selectedInstance, userData } = storeToRefs(useLoginStore());
    const loginUser = computed(() => userData.value?.loginUser ?? null);
    const { language } = useUser();
    const isReady = ref(false);

    function init(): void {
        if (appSettings.saltfishKey === '' || appSettings.enableSaltfish === false) {
            console.warn('Saltfish key is not set or Saltfish is disabled');
            return;
        }

        void saltfish.init({
            token: appSettings.saltfishKey,
        });

        isReady.value = true;
    }

    function identify(userId: string, traits?: Record<string, unknown>): void {
        if (isReady.value !== true) return;
        saltfish.identify(userId, traits);
    }

    watch([
        (): unknown => loginUser.value,
        (): unknown  => selectedInstance.value,
        (): unknown  => language.value,
    ], () => {
        identify(loginUser.value?.Id ?? 'unknown', {
            email: loginUser.value?.Email,
            customer: selectedInstance.value?.SubDomain,
            language: language.value,
        });
    });

    return { init, identify };
}
